import { render, staticRenderFns } from "./SlotsActions.vue?vue&type=template&id=34ed7f3a&scoped=true&lang=pug&"
import script from "./SlotsActions.vue?vue&type=script&lang=js&"
export * from "./SlotsActions.vue?vue&type=script&lang=js&"
import style0 from "./SlotsActions.vue?vue&type=style&index=0&id=34ed7f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34ed7f3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
